import { BaseContainerModel } from "../base-container.model";
import {
  bl_mkp_entity_branch_stock_balance_RowInterface,
  bl_mkp_entity_branch_stock_balance_RowClass,
} from "../../dbschema/index";

export class MkpEntityBranchStockBalanceContainer extends BaseContainerModel {
  bl_mkp_entity_branch_stock_balance: bl_mkp_entity_branch_stock_balance_RowInterface =
    new bl_mkp_entity_branch_stock_balance_RowClass();
} 
